import { useCallback } from 'react';

import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { useAnalytics } from '@atlassian/conversation-assistant-instrumentation/controllers/analytics';

/**
 * Returns a sender for Rovo Chat analytics-coverage events. Events are only sent while
 * `rovo_chat_analytics_coverage` is on, so gate-off behaviour is unchanged.
 */
export const useAnalyticsCoverageEvent = (): ((payload: AnalyticsEventPayload) => void) => {
	const { sendAnalyticsEvent } = useAnalytics();
	return useCallback(
		(payload: AnalyticsEventPayload) => {
			if (fg('rovo_chat_analytics_coverage')) {
				sendAnalyticsEvent(payload);
			}
		},
		[sendAnalyticsEvent],
	);
};
